import { atom } from "jotai";
import { ShareGraphQlAdapter } from "@/infrastructure/adapters/graphQl/ShareGraphQl.adapter";
import { AnalyticsRepository } from "@/infrastructure/repositories/analytics/Analytics.repository";
import { GetAnalyticsShareLinkUseCase } from "@/core/usecases/analytics/GetAnalyticsShareLink.useCase";
import { toPublicShareToken } from "@/core/utils/shareToken";
import { ApplicationError } from "@/infrastructure/errors/ApplicationError";
import { shareLinkAtom } from "./shareLink.atoms";

export const fetchShareLinkAtom = atom(null, async (get, set, token: string) => {
  const publicToken = toPublicShareToken(token);
  const current = get(shareLinkAtom);

  if (current.fetchedToken === publicToken && (current.status === "loading" || current.status === "valid")) {
    return;
  }

  set(shareLinkAtom, { status: "loading", shareLink: null, error: null, fetchedToken: publicToken });

  try {
    ShareGraphQlAdapter.getInstance().setShareToken(publicToken);
    const repo = new AnalyticsRepository(ShareGraphQlAdapter.getInstance().getClient());
    const shareLink = await new GetAnalyticsShareLinkUseCase(repo).execute();

    set(shareLinkAtom, { status: "valid", shareLink, error: null, fetchedToken: publicToken });
  } catch (error: unknown) {
    const err = error as Error;
    const isExpired =
      err instanceof ApplicationError && err.message === "SHARE_LINK_EXPIRED";

    set(shareLinkAtom, {
      status: isExpired ? "expired" : "error",
      shareLink: null,
      error: err,
      fetchedToken: publicToken,
    });
  }
});

export const resetShareLinkAtom = atom(null, (_get, set) => {
  ShareGraphQlAdapter.getInstance().clearShareToken();
  set(shareLinkAtom, { status: "idle", shareLink: null, error: null, fetchedToken: null });
});
